import React, { useState, useCallback } from 'react';
import { getAllChefList } from '../../../services/FoodItemsService';
import ChefList from '../../components/FoodMenu/ChefList';

const Chefs = () => {

    const [chefList, setChefList] = useState();

    const getChefList = useCallback(() => {
        getAllChefList().then(res => {
            res.sort((a, b) => (a.id > b.id) ? 1 : ((b.id > a.id) ? -1 : 0));
            setChefList(res);
        });
    }, []);
    return (
        <ChefList chefList={chefList} getChefList={getChefList} />
    );
}


export default Chefs;
